var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BaseButton",class:_vm.elmClasses},[_c(_vm.tag,{tag:"component",staticClass:"BaseButton__inner",attrs:{"disabled":_vm.disabled},domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('div',{staticClass:"BaseButton__border"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }